// 앱 전역 MUI 테마 생성기.
// 디자인 토큰(palette / typography / shape)은 createTheme의 1번째 인자로 넣어
// factory(createPalette / createTypography)가 실행되게 한다.
//  - success/warning/error/info의 light·dark·contrastText 보정
//  - 모든 타이포 variant에 fontFamily(시스템 폰트 스택) 상속
// RefineThemes의 컴포넌트 오버라이드(MuiButton 등)는 deepmerge로 보존한다.
// 마지막 인자들(koKR, koKRCore)로 DataGrid 툴바 + 그리드 페이지네이션이 한글화된다.
//  - koKR (x-data-grid): 툴바 "열 목록 / 행 간격 / 내보내기", "페이지 당 행:"
//  - koKRCore (@mui/material): "1–20 / 18147" 형태의 labelDisplayedRows

import { createTheme, Theme } from "@mui/material/styles";
import type { Components } from "@mui/material/styles";
import { koKR as koKRCore } from "@mui/material/locale";
import { deepmerge } from "@mui/utils";
import { RefineThemes } from "@refinedev/mui";
import { koKR } from "@mui/x-data-grid/locales";
import { lightPalette, darkPalette, typography, shape } from "./tokens";
import { componentOverrides } from "./components";

export const createAppTheme = (mode: "light" | "dark"): Theme => {
  const base = mode === "light" ? RefineThemes.Blue : RefineThemes.BlueDark;

  const mergedComponents = deepmerge(
    base.components ?? {},
    componentOverrides()
  ) as Components<Theme>;

  return createTheme(
    {
      palette: mode === "light" ? lightPalette : darkPalette,
      typography,
      shape,
      components: mergedComponents,
    },
    koKR,
    koKRCore
  );
};
